import AttachCourseModal from "@/features/leads/components/view-lead/components/Ongoing/components/AttachCourseModal";
import type { NicheModalProps } from "../nicheRegistry";

// Close no longer refetches: useAttachVariant refreshes deal/lead caches on
// success, and a plain cancel changed nothing. In create mode (no deal yet)
// the modal creates the lead's first deal with the picked course.
export default function AttachCourseModalAdapter({
  open,
  onClose,
  child,
  createForLead,
}: NicheModalProps) {
  return (
    <AttachCourseModal
      open={open}
      onClose={onClose}
      dealId={child?.id ?? null}
      dealName={child?.name || createForLead?.name || "Deal"}
      createForLead={createForLead ?? null}
    />
  );
}
